import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { unauthHeaders } from '../../utils/API';
import Agreement from './Agreement';

const AgreementContainer = () => {
    const [isLoading, setIsLoading] = useState(false);

    const getAgreement = () => {
        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/profile/agreement-document?typeAgreement=useragreement`, {
            headers: {
                ...unauthHeaders,
            }
        })
            .then((res) => {
                setIsLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    }

    useEffect(() => {
        getAgreement();
    }, [])

    return (
        <Agreement
            isLoading={isLoading}
        />
    )
}

export default AgreementContainer;
